export default {"src":"/_next/static/media/0x35751007a407ca6feffe80b3cb397736d2cf4dbe.82a638d4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};